﻿import React, { useMemo } from 'react';
import { str_isEmpty } from '@Util/Utils';
import { Input_With_Label_Props } from '@Util/Types';
import { Tooltip } from 'react-tooltip';

export default function Input_With_Label({
    id,
    className,
    error,
    label,
    type,
    value,
    onChange,
    info_text
}: Input_With_Label_Props): JSX.Element {
    const tooltip_id: string = `${id}_tooltip`;

    const elementClass = useMemo(() => {
        let classStr = "Form_Row";

        if (!str_isEmpty(className)) {
            classStr += ` ${className}`;
        }

        if (error) {
            classStr += " Form_Row--Error";
        }

        return classStr;
    }, [className, error]);

    return (
        <div className={elementClass}>
            {label && <label htmlFor={id}>{label}</label>}
            <input
                type={type}
                value={value}
                onChange={onChange}
                id={id}
                name={id}
            />
            {info_text && (
                <>
                    <a
                        className="Info_Text"
                        data-tooltip-id={tooltip_id}
                        data-tooltip-content={info_text}
                        data-tooltip-place="top"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" height="48" width="48" viewBox="0 96 960 960">
                            <path d="M484 809q16 0 27-11t11-27q0-16-11-27t-27-11q-16 0-27 11t-11 27q0 16 11 27t27 11Zm-35-146h59q0-26 6.5-47.5T555 566q31-26 44-51t13-55q0-53-34.5-85T486 343q-49 0-86.5 24.5T345 435l53 20q11-28 33-43.5t52-15.5q34 0 55 18.5t21 47.5q0 22-13 41.5T508 544q-30 26-44.5 51.5T449 663Zm31 313q-82 0-155-31.5t-127.5-86Q143 804 111.5 731T80 576q0-83 31.5-156t86-127Q252 239 325 207.5T480 176q83 0 156 31.5T763 293q54 54 85.5 127T880 576q0 82-31.5 155T763 858.5q-54 54.5-127 86T480 976Z" />
                        </svg>
                    </a>
                    <Tooltip id={tooltip_id} />
                </>
            )}
        </div>
    );
}